var React = require('react');

function AppleIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #b5b5b5;\n        stroke-width: 0px;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M11.72,13.86c-.66.98-1.35,1.98-2.42,1.98s-1.4-.63-2.61-.63-1.58.61-2.59.65-1.82-1.07-2.45-2.03c-1.35-1.96-2.38-5.54-1-7.98.66-1.18,1.88-1.94,3.23-1.99,1.01,0,1.98.69,2.61.69s1.79-.85,3.02-.72c1.16.04,2.22.63,2.88,1.58-1.04.65-1.69,1.79-1.7,3.02.02,1.38.85,2.63,2.12,3.17-.26.8-.62,1.55-1.09,2.24M7.2,1.19c.6-.67,1.43-1.1,2.33-1.19.08.91-.2,1.82-.79,2.53-.57.73-1.45,1.15-2.38,1.12-.06-.9.24-1.79.84-2.46Z","key":1})]);
}

AppleIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","width":"24px","height":"24px"};

module.exports = AppleIcon;

AppleIcon.default = AppleIcon;
